// extracted by mini-css-extract-plugin
module.exports = {"QuestionsContainer":"QuestionListContainer_QuestionsContainer__uBjLb","Title":"QuestionListContainer_Title__1YYre"};